// ─── Pure UI/display helpers used across Dashboard subcomponents ───
// Keep these stateless — no hooks, no fetches.

export const getClassificationBadge = (classification) => {
  const styles = {
    'Hot Deal': 'bg-gradient-to-r from-orange-500/20 to-red-500/20 text-orange-600 border border-orange-500/30',
    'SQL': 'badge-sql',
    'Warm Lead': 'bg-yellow-500/15 text-amber-600 border border-yellow-500/30',
    'Cold Lead': 'bg-blue-500/15 text-blue-600 border border-blue-500/30',
    'Disqualified': 'bg-destructive/15 text-destructive border border-destructive/30',
    'Pending': 'bg-secondary text-muted-foreground'
  };
  return styles[classification] || styles['Pending'];
};

export const getRiskBadge = (riskStatus) => {
  const styles = {
    'Critical': 'bg-destructive text-white',
    'High': 'bg-destructive/80 text-white',
    'Medium': 'bg-warning/80 text-white',
    'Low': 'bg-success/20 text-success'
  };
  return styles[riskStatus] || styles['Low'];
};

export const getDealHealthColor = (grade) => {
  const colors = {
    'Hot Deal': 'text-orange-600',
    'SQL': 'text-success',
    'Warm Lead': 'text-amber-600',
    'Cold Lead': 'text-blue-600',
    'Disqualified': 'text-destructive'
  };
  return colors[grade] || 'text-muted-foreground';
};

export const getScoreColor = (score) => {
  if (score >= 86) return 'text-orange-600';
  if (score >= 71) return 'text-success';
  if (score >= 51) return 'text-warning';
  return 'text-destructive';
};

export const getWinProbability = (score) => {
  if (score >= 90) return { pct: Math.round(90 + (score - 90) * 1), label: 'Very High', color: 'text-emerald-600' };
  if (score >= 75) return { pct: Math.round(70 + (score - 75) / 15 * 20), label: 'High', color: 'text-success' };
  if (score >= 60) return { pct: Math.round(50 + (score - 60) / 15 * 20), label: 'Promising', color: 'text-amber-600' };
  if (score >= 40) return { pct: Math.round(30 + (score - 40) / 20 * 20), label: 'Medium', color: 'text-orange-600' };
  return { pct: Math.round(10 + score / 40 * 20), label: 'Low', color: 'text-destructive' };
};

export const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const formatDuration = (seconds) => {
  if (!seconds) return '--:--';
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

export const formatDealValue = (v) => {
  if (!v) return null;
  if (v >= 1000000) return `$${(v / 1000000).toFixed(1)}M`;
  if (v >= 1000) return `$${(v / 1000).toFixed(0)}K`;
  return `$${v.toLocaleString()}`;
};
